// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__t7P9J","logo":"Logo_logo__WxeP5"};